/*
 * MyTh Ahmed Faiz Copyright © 2016-2022 All rights reserved.
 * Email: mythpe@gmail.com
 * Mobile: +966590470092
 * Website: https://www.4myth.com
 */

const files = require.context('@plugins', true, /index.js$/i)
files.keys().map((key) => files(key))
